<template>
  <animated-background>
    <div class="h-50 w-100 d-flex flex-column align-items-center pt-3">
      <px-logo :link="$t('homepage.logo_link')"></px-logo>
      <div class="flex-fill d-flex flex-column justify-content-center align-items-center">
        <h1 class="h1 main-title">{{$t('homepage.title')}}</h1>
        <p class="subheader">{{$t('homepage.subtitle')}}</p>
        <div><px-button @click="launchSimulation" :text="$t('homepage.cta')"></px-button></div>
      </div>
      <div class="privacy_policy_link">
        <a target="_blank" :href="$t('homepage.privacy_policy_url')">{{$t('homepage.privacy_policy_btn')}}</a>
      </div>
    </div>
  </animated-background>
</template>

<script>
import { AnimatedBackground } from '@/components/UIComponents'

export default {
  name: 'Homepage',
  components: {
    AnimatedBackground
  },
  methods: {
    launchSimulation () {
      this.$router.push({name: 'simulation'})
    }
  }
}
</script>
